import { observable, action, computed } from 'mobx';
import { message } from 'antd';
import { WeaTools, WeaInputLocale, WeaLocaleProvider } from 'ecCom';

import * as LOGIN_API from '../apis/login';
import { doEvent } from '../util/eventUtil';
import { addContentPath } from '../util/pathUtil';
import { getCookieValue, getLSValue, setLSValue, initLSValue } from '../util/loginUtil';
import { loadModule, registerComs } from '../util/loadjsUtil';
import { ecComFiles, comMobxFiles, portalPublicFiles } from '../constants/files';

const { ua } = WeaTools;
const { getCurrentLabel, getMultiStrFromBase64 } = WeaInputLocale;
const { getLabel } = WeaLocaleProvider;

export default class LoginStore {
  // 登录页加载状态
  @observable loading = true;
  // 浏览器地址查询参数
  @observable queryParams = {};
  // 升级状态，状态为0时正常显示登录页，否则跳转升级页面
  @observable updatestatus = '';
  // CAS状态，状态为0时正常显示登录页，否则跳转登录后页面
  @observable casstatus = '';
  // 多语言
  @observable multiLangs = getLSValue('login', 'multiLangs') || [];
  // 动态密码有效时间
  @observable dynamicPasswordTime = 0;
  @observable dynamicPasswordInterval = 0;
  // 登录验证码刷新参数
  @observable seriesnum_ = 0;
  // 二维码有效时间
  @observable qrcodeValidTime = 30;
  @observable qrcodeReqTime = 1;
  // 二维码请求次数
  @observable qrcodeUsedTime = 0;
  @observable pollingTimeout = "";
  // 二维码是否已失效
  @observable qrcodeIsInvalid = false;
  // 移动客户端下载地址
  @observable emobileDownloadUrl = '';
  // 登录表单数据加载状态
  @observable loginFormDataLoading = false;
  // 自定义登录组件加载状态
  @observable customloading = false;
  // 登录页事件加载状态
  @observable beforLoginRenderEventStatus = false;
  @observable afterLoginRenderEventStatus = false;
  // 登录页状态
  @observable state = Object.assign(
    {},
    {
      win_width: jQuery(window).width(),
      win_height: jQuery(window).height(),
      isLogging: false,
      hasMultiLang: false,
      multiLangVisible: false,
      loginFormItems: [],
      loginFormHiddenItems: [],
      loginSetting: {},
      qrCode: {},
      validateCode: '/weaver/weaver.file.MakeValidateCode?seriesnum_=0',
      labelInfo: [],
    },
    Object.assign({}, getLSValue('login', 'loginCache'), {
      loginType: getLSValue('login', 'loginType') || 'form',
      langId: getLSValue('login', 'langId') || '7',
      langText: getLSValue('login', 'langText') || '',
      isRememberAccount: getLSValue('login', 'isRememberAccount') || getCookieValue('isRememberAccount') || false,
      isRememberPassword: getLSValue('login', 'isRememberPassword') || getCookieValue('isRememberPassword') || false,
      cacheAccount: getLSValue('login', 'cacheAccount') || getCookieValue('cacheAccount') || '',
      cachePassword: getLSValue('login', 'cachePassword') || getCookieValue('cachePassword') || '',
      initialSlide: getLSValue('login', 'initialSlide') || 0,
      autoCarousel: getLSValue('login', 'autoCarousel') || false,
      carouselTime: getLSValue('login', 'carouselTime') || 3,
    })
  );

  constructor() {
    this.onWindowResize = this.onWindowResize.bind(this);
    this.setQueryParams = this.setQueryParams.bind(this);
    this.setState = this.setState.bind(this);
    this.setStateAndCache = this.setStateAndCache.bind(this);
    this.onBgImageChange = this.onBgImageChange.bind(this);
    this.getLoginBgImageStyle = this.getLoginBgImageStyle.bind(this);
    this.getElementStyle = this.getElementStyle.bind(this);
    this.getMultiLangs = this.getMultiLangs.bind(this);
    this.getUpgradeInfo = this.getUpgradeInfo.bind(this);
    this.getLoginInfo = this.getLoginInfo.bind(this);
    this.getLoginForm = this.getLoginForm.bind(this);
    this.onPasswordForget = this.onPasswordForget.bind(this);
    this.onRememberChange = this.onRememberChange.bind(this);
    this.onValidateCodeChange = this.onValidateCodeChange.bind(this);

    jQuery(window).resize(() => this.onWindowResize());
  }

  setTitle = () => {
    const { langId, loginTemplateTitle, loginTemplateTitle_base64 } = this.state;
    if (loginTemplateTitle_base64) {
      document.title = getCurrentLabel(getMultiStrFromBase64(loginTemplateTitle_base64), langId) || loginTemplateTitle;
    } else {
      document.title = loginTemplateTitle;
    }
  };

  @computed
  get labelObj() {
    const { langId, labelInfo, loginTemplateTitle, loginTemplateTitle_base64 } = this.state;
    if (loginTemplateTitle_base64) {
      document.title = getCurrentLabel(getMultiStrFromBase64(loginTemplateTitle_base64), langId) || loginTemplateTitle;
    } else {
      document.title = loginTemplateTitle;
    }
    return labelInfo[`langid${langId}`] || {};
  }

  @action
  onWindowResize() {
    const width = jQuery(window).width();
    const height = jQuery(window).height();

    if (width < 800) {
      jQuery('#LoginContainer').css({ overflowX: 'scroll' });
    } else {
      jQuery('#LoginContainer').css({ overflowX: 'hidden' });
    }

    if (height < 660) {
      jQuery('#LoginContainer').css({ overflowY: 'scroll' });
    } else {
      jQuery('#LoginContainer').css({ overflowY: 'hidden' });
    }

    this.setState({
      win_width: width < 800 ? 800 : width,
      win_height: height < 660 ? 660 : height,
    });
  }

  @action
  setQueryParams(params = {}) {
    this.queryParams = params;
    window.queryParams = params;
    WeaTools.ls.set('login-pop-params', params);
  }

  @action
  setState(state) {
    this.state = Object.assign({}, this.state, state);

    if (state.langId && state.langText && getLSValue("login", "loginTypeSetting") == undefined) {
      setLSValue('login', 'langId', state.langId);
      setLSValue('login', 'langText', state.langText);
      WeaTools.ls.set('languageidweaver', state.langId);
    }
  }

  @action
  setStateAndCache(key, value) {
    this.setState({ [key]: value });
    setLSValue('login', key, value);
  }

  @action
  onBgImageChange(params, index) {
    const { imgsrc, width, height } = params;
    const loginInfo = Object.assign({}, this.state.loginSettingInfo.loginInfo, { imgsrc, width, height });
    const loginSettingInfo = Object.assign({}, this.state.loginSettingInfo, { loginInfo });
    this.setState({ loginSettingInfo, initialSlide: index });

    setLSValue('login', 'initialSlide', index);
    setLSValue('login', 'loginBgImage', imgsrc);
    setLSValue('login', 'loginBgImageWidth', width);
    setLSValue('login', 'loginBgImageHeight', height);
  }

  @action
  getLoginBgImageStyle(loginInfo) {
    const { fillStyle } = loginInfo;
    const src = getLSValue('login', 'loginBgImage') || loginInfo.imgsrc;
    const width = getLSValue('login', 'loginBgImageWidth') || loginInfo.width;
    const height = getLSValue('login', 'loginBgImageHeight') || loginInfo.height;

    let style = { backgroundImage: `url(${addContentPath(src)})` };
    switch (fillStyle) {
      case 'adapt':
      case 'fill': {
        style.backgroundRepeat = 'no-repeat';
        style.backgroundSize = 'cover';
        let _style = {};
        let win_width = jQuery(window).width();
        let win_height = jQuery(window).height();
        win_width = win_width < 800 ? 800 : win_width;
        win_height = win_height < 660 ? 660 : win_height;
        let rate = width / height;
        let _rate = win_width / win_height;
        if (rate > _rate) {
          if (fillStyle == 'adapt') {
            _style = {
              width: win_width,
              height: win_width / rate,
              marginTop: (win_height - win_width / rate) / 2,
            };
          }
          if (fillStyle == 'fill') {
            _style = {
              width: win_height * rate,
              height: win_height,
              marginLeft: -((win_height * rate - win_width) / 2),
            };
          }
        } else if (rate < _rate) {
          if (fillStyle == 'adapt') {
            _style = {
              width: win_height * rate,
              height: win_height,
              marginLeft: (win_width - win_height * rate) / 2,
            };
          }
          if (fillStyle == 'fill') {
            _style = {
              width: win_width,
              height: win_width / rate,
            };
          }
        } else {
          _style = {
            width: win_width,
            height: win_height,
          };
        }
        style = { ...style, ..._style };
        break;
      }
      case 'tile':
        style.backgroundRepeat = 'repeat';
        break;
      case 'center':
        style.backgroundPosition = 'center';
        style.backgroundRepeat = 'no-repeat';
        break;
      default:
        style.backgroundRepeat = 'no-repeat';
        style.backgroundSize = '100% 100%';
        break;
    }
    return style;
  }

  @action
  getElementStyle(element) {
    const { win_width, win_height, loginType, loginFormItems, templateType } = this.state;
    let { showtype, isAbsolute, width, height, imgWidth, imgbtn, isloginbtn, imgHeight, rate_x, rate_y, level, vertical, levelMargin, verticalMargin } = element;

    if (!width) {
      width = win_width;
    }
    if (!height) {
      height = win_height;
    }
    if (!imgWidth) {
      imgWidth = win_width;
    }
    if (!imgHeight) {
      imgHeight = win_height;
    }

    let style = {};
    if (isAbsolute == 1) {
      if (isloginbtn == false) {
        // 老数据
        style = {
          left: `${rate_x * 100}%`,
          width: imgWidth,
          height: imgHeight,
        };
      } else {
        style = {
          left: `${rate_x * 100}%`,
          top: `${rate_y * 100}%`,
          width,
          height,
        };
      }
    } else {
      if (imgbtn == true) {
        // 图片按钮
        let left = 0;
        switch (level) {
          case 'left':
            left = levelMargin;
            break;
          case 'center':
            left = (win_width - imgWidth) / 2 + levelMargin;
            break;
          case 'right':
            left = win_width - imgWidth - levelMargin;
            break;
        }

        let top = 0;
        switch (vertical) {
          case 'top':
            top = verticalMargin;
            break;
          case 'middle':
            top = (win_height - imgHeight) / 2 + verticalMargin;
            break;
          case 'bottom':
            top = win_height - imgHeight - verticalMargin;
            break;
        }
        style = { left, top, width, height };
      } else {
        // 登录按钮
        let left = 0;
        switch (level) {
          case 'left':
            left = levelMargin;
            break;
          case 'center':
            left = (win_width - width) / 2 + levelMargin;
            break;
          case 'right':
            left = win_width - width - levelMargin;
            break;
        }

        let top = 0;
        switch (vertical) {
          case 'top':
            top = verticalMargin;
            break;
          case 'middle':
            top = (win_height - height) / 2 + verticalMargin;
            break;
          case 'bottom':
            top = win_height - height - verticalMargin;
            break;
        }
        style = { left, top, width, height };
      }

      if (loginType == 'form' && (templateType == 'E9' || templateType == 'V' || templateType == 'H' || templateType == 'Ecology8')) {
        const len = loginFormItems.length - 2;
        if (len > 0) {
          if (showtype == 'loginbox') {
            style.height += len * 65;
            style.top -= len * 32.5;
          }
          if (showtype == 'logo' || showtype == 'loginForm' || showtype == 'qrcode' || showtype == 'loginButton') {
            style.top -= len * 32.5;
          }
        }
      }
    }
    return style;
  }

  @action
  doBeforLoginRenderEvent() {
    // 防止重复执行
    if (!this.beforLoginRenderEventStatus) {
      doEvent('beforLoginRender', () => (this.beforLoginRenderEventStatus = true));
    }
  }

  @action
  doAfterLoginRenderEvent() {
    // 防止重复执行
    if (!this.afterLoginRenderEventStatus) {
      doEvent('afterLoginRender', () => (this.afterLoginRenderEventStatus = true));
    }
  }

  @action
  getMultiLangs(params = {}) {
    LOGIN_API.getActiveLanguage(params).then((result) => {
      if (result.status == '1') {
        const { activeLanguageInfo, activeLanguageIds, languageIdentify, systemDefaultLang = {} } = result;

        this.multiLangs = activeLanguageInfo;

        setLSValue('login', 'multiLangs', activeLanguageInfo);
        WeaTools.ls.set('activeLanguageIds', activeLanguageIds);
        WeaTools.ls.set('languageIdentify', languageIdentify);

        // 当前状态中没有语言时，取默认语言
        if (!this.state.langId) {
          let language = {};
          for (let key in systemDefaultLang) {
            language = { id: key, language: systemDefaultLang[key] };
          }
          const { id: langId = '7', language: langText = '简体中文' } = language;
          this.setState({ langId, langText });
          this.getLoginForm({ langId });
        }
      }

      this.setTitle();
    });
  }

  @action
  getUpgradeInfo(params = {}) {
    LOGIN_API.getUpgradeInfo(params).then((result) => {
      const { updatestatus, upgradeurl } = result;
      if (updatestatus == '0') {
        if (/E-Mobile/i.test(window.navigator.userAgent)) {
          let paramstr = '';
          Object.keys(params).map((key) => {
            paramstr += `&${key}=${params[key]}`;
          });
          if (paramstr != '') {
            paramstr = paramstr.substring(1);
          }
          if (params.service) {
            window.location.href = addContentPath(`/spa/portal/static4mobilelogin/index.html?service=${params.service}#/login?${paramstr}`);
          } else {
            window.location.href = addContentPath(`/spa/portal/static4mobilelogin/index.html#/login?${paramstr}`);
          }
        } else {
          this.doBeforLoginRenderEvent();

          // 检查是否部署了CAS
          LOGIN_API.checkCasIsDeployed().then((result) => {
            const { isDeployed, hasSession } = result;
            LOGIN_API.getIsJumpAfterlogin().then((result1)=>{
              const { value = '1' } = result1;
              if(parseInt(value)==1){
                // 用户已登录，则直接跳转登录后页面（进入登录后）
                if (hasSession && !params.preview && !params.templateType) {
                  doEvent('afterLogin', () => {
                    if (getLSValue('login', 'logintype') == '2') {
                      window.location.href = `${window.ecologyContentPath || ''}/spa/crmPortal/mobx/index.html#/main`;
                    } else {
                      window.location.href = `${window.ecologyContentPath || ''}/wui/index.html?#/main`
                    }
                  });
                } else {
                  this.getLoginInfo(params);
                }
              }else{
                  this.getLoginInfo(params);
              }
            })
          });
        }
      } else if (upgradeurl) {
        window.location.href = addContentPath(upgradeurl);
      }
    });
  }

  @action
  getLoginInfo(params = {}, callback) {
    this.updatestatus = '0';
    this.casstatus = '0';

    if(window.hasloginpop){
      // 弹出登录弹窗的情况下，手动删除浏览器参数，回到登录页，清除掉超时登录框
      delete window.hasloginpop;
      var WeaLoginPopList = document.getElementsByClassName("wea-login-pop");
      for (var i = 0, len = WeaLoginPopList.length; i < len; i++) {
        WeaLoginPopList[i].remove();
     }
    }
    
    // 获取多语言
    this.getMultiLangs(params);

    this.loading = true;
    LOGIN_API.getLoginInfo(params).then((result) => {
      // 缓存登录日期
      const date = new Date();
      const loginDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      WeaTools.ls.set('loginDate', loginDate);

      if (result.status != '2') {
        const {
          settingversion,
          id: templateId,
          templateType,
          loginSettingInfo = {},
          bgImagesInfo = [],
          layoutData = {},
          isRememberAccount,
          isRememberPassword,
          cacheAccount = '',
          cachePassword = '',
          emobileDownloadUrl,
        } = result;
        const { loginInfo = {} } = loginSettingInfo;
        const { showQrcode, qrcodeValidTime = 30, qrcodeReqTime = 1, defaultQrcode, onlyQrcode } = loginInfo;

        // 判断接口返回的设置版本和缓存的设置版本是否一致
        const ls_settingversion = getLSValue('login', 'settingversion');
        const ls_templateId = getLSValue('login', 'templateId');
        const isNewVersion = settingversion != ls_settingversion || templateId != ls_templateId;

        // 设置移动客户端下载地址
        this.emobileDownloadUrl = emobileDownloadUrl;

        // 获取登录方式
        this.qrcodeValidTime = qrcodeValidTime;
        this.qrcodeReqTime = qrcodeReqTime;
        let loginType = 'form';
        if (showQrcode) {
          if (onlyQrcode) {
            loginType = 'QRCode';
          } else {
            const ls_loginType = getLSValue('login', 'loginType') || '';
            loginType = ls_loginType || (defaultQrcode ? 'QRCode' : 'form');
          }
        }
        setLSValue('login', 'loginType', loginType);

        // 获取幻灯片默认位置
        let initialSlide = 0;
        const ls_loginBgImage = !isNewVersion ? getLSValue('login', 'loginBgImage') : '';
        const loginBgImage = ls_loginBgImage || loginInfo.imgsrc;
        for (let i = 0, len = bgImagesInfo.length; i < len; i++) {
          if (bgImagesInfo[i].imgsrc == loginBgImage) {
            initialSlide = i;
            break;
          }
        }
        setLSValue('login', 'initialSlide', initialSlide);

        // 获取幻灯片是否自动轮播
        const ls_autoCarousel = !isNewVersion ? getLSValue('login', 'autoCarousel') : undefined;
        const autoCarousel = ls_autoCarousel != undefined ? ls_autoCarousel : loginInfo.autoCarousel;
        setLSValue('login', 'autoCarousel', autoCarousel);

        // 获取幻灯片自动轮播间隔时间
        const ls_carouselTime = !isNewVersion ? getLSValue('login', 'carouselTime') : '';
        const carouselTime = ls_carouselTime || loginInfo.carouselTime;
        setLSValue('login', 'carouselTime', carouselTime);

        // 获取记住的账号和密码
        if (isRememberAccount != undefined) {
          setLSValue('login', 'isRememberAccount', isRememberAccount);
          setLSValue('login', 'isRememberPassword', isRememberPassword);
          setLSValue('login', 'cacheAccount', cacheAccount);
          setLSValue('login', 'cachePassword', cachePassword);
          this.setState({ isRememberAccount, isRememberPassword, cacheAccount, cachePassword });
        }

        const state = Object.assign({}, result, { loginType, initialSlide, autoCarousel, carouselTime });
        setLSValue('login', 'loginCache', state);

        if (isNewVersion || templateType == 'ECustom') {
          setLSValue('login', 'settingversion', settingversion);
          setLSValue('login', 'templateId', templateId);
          setLSValue('login', 'templateType', templateType);
          setLSValue('login', 'loginBgImage', loginInfo.imgsrc);
          setLSValue('login', 'loginBgImageWidth', loginInfo.width);
          setLSValue('login', 'loginBgImageHeight', loginInfo.height);

          this.setState(state);

          if (templateType == 'ECustom') {
            this.onLoadECustomLogin(layoutData);
          }
        }

        this.setTitle();
      }
      if (callback && typeof callback == 'function') {
        callback();
      }
      this.loading = false;
    });
  }

  @action
  onLoadECustomLogin(layoutData = {}) {
    const { layoutCustom, layoutConfig } = layoutData;

    if (layoutCustom == '1' && layoutConfig && layoutConfig.id) {
      registerComs();
      WeaTools.loadDevModules(layoutConfig.id, layoutConfig.module).then(() => {
        const _interval = window.setInterval(() => {
          if (window[layoutConfig.module]) {
            this.customloading = true;
            window.clearInterval(_interval);
          }
        }, 100);
      });
    } else {
      loadModule({
        module: 'portalPublic',
        files: [...ecComFiles, ...comMobxFiles, ...portalPublicFiles],
        success: () => {
          const _interval = window.setInterval(() => {
            if (window.weaPortalPublic) {
              this.customloading = true;
              window.clearInterval(_interval);
            }
          }, 100);
        },
      });
    }
  }

  @action
  getLoginForm(params = {}, callback) {
    const queryParams = this.queryParams;
    const { logintype = '1' } = queryParams;
    const { loginId = '', langId = this.state.langId } = params;

    if (langId) {
      window.doLoginAction &&
        window.doLoginAction('getLoginForm', {
          queryParams,
          logintype,
          loginid: loginId,
          langid: langId,
          callback: (result) => {
            const { hasMultiLang = false, loginFormItems = [], loginFormHiddenItems = [], loginSetting = {}, qrCode = {} } = result;
            this.setState({ hasMultiLang, loginFormItems, loginFormHiddenItems, loginSetting, qrCode });
            if (callback && typeof callback == 'function') {
              callback(result);
            }
            // 登录表单数据加载完成
            this.loginFormDataLoading = true;
          },
        });
    }
  }

  @action
  getDynamicPassword() {
    const queryParams = this.queryParams;
    const { logintype = '1' } = queryParams;
    const { langId, loginSetting } = this.state;

    window.doLoginAction &&
      window.doLoginAction('getDynamicPassword', {
        queryParams,
        logintype,
        langid: langId,
        loginSetting,
        success: (result) => {
          const { validitySec = 60 } = result;
          this.dynamicPasswordTime = validitySec;

          const _interval = setInterval(() => {
            const time = this.dynamicPasswordTime;
            if (time == 1) {
              window.clearInterval(this.dynamicPasswordInterval);
            }
            this.dynamicPasswordTime = time - 1;
          }, 1000);
          this.dynamicPasswordInterval = _interval;
        },
      });
  }

  @action
  onRememberChange(type, checked) {
    const { isRememberAccount, isRememberPassword } = this.state;
    if (type == 'account') {
      this.setState({
        isRememberAccount: checked,
        isRememberPassword: !checked ? checked : isRememberPassword,
      });
    } else if (type == 'password') {
      this.setState({
        isRememberAccount: checked || isRememberAccount,
        isRememberPassword: checked,
      });
    }
  }

  @action
  onPasswordForget(params = {}) {
    const { langId = this.state.langId } = params;
    window.doLoginAction && window.doLoginAction('forgetPassword', { langid: langId });
  }

  @action
  onValidateCodeChange() {
    setTimeout(() => this.setState({ validateCode: `/weaver/weaver.file.MakeValidateCode?seriesnum_=${++this.seriesnum_}` }), 50);
  }

  @action
  onLogin() {
    const queryParams = this.queryParams;
    const { logintype = '1', gopage = '', target = '1' } = queryParams;
    const { langId, langText, isRememberAccount, isRememberPassword, loginSetting, loginSettingInfo = {} } = this.state;
    const { loginInfo = {} } = loginSettingInfo;
    const { isOpenGopage = true } = loginInfo;

    WeaTools.ls.set('login-pop-window.location', window.location);

    this.setState({ isLogging: true });
    doEvent('beforLogin', () => {
      window.doLoginAction &&
        window.doLoginAction('login', {
          queryParams,
          logintype,
          langid: langId,
          loginSetting,
          isRememberAccount,
          isRememberPassword,
          success: (username, password, result = {}) => {
            // 设置多时区
            jQuery.setSessionTimeZone && jQuery.setSessionTimeZone();

            setLSValue('login', 'logintype', logintype);

            // 记住账号密码
            let cacheAccount = '';
            let cachePassword = '';
            if (isRememberAccount) {
              cacheAccount = username;
            }
            if (isRememberPassword) {
              cachePassword = password;
            }
            this.setState({ isRememberAccount, isRememberPassword, cacheAccount, cachePassword });

            initLSValue(username, langId);
            setLSValue('login', 'loginId', username);
            setLSValue('login', 'cacheAccount', cacheAccount);
            setLSValue('login', 'cachePassword', cachePassword);
            setLSValue('login', 'isRememberAccount', isRememberAccount);
            setLSValue('login', 'isRememberPassword', isRememberPassword);

            // 跳转
            const params = { isOpenGopage };
            this.onLoginJump(params, queryParams, result);
          },
          failure: (result = {}) => {
            this.setState({ isLogging: false });
            // 刷新验证码
            if (result.reflashValidateCode) {
              this.onValidateCodeChange();
            }
            this.getLoginForm({}, (result = {}) => {
              const { loginSetting = {}, message: warningMsg } = result;
              const { userUsbType } = loginSetting;
              // 只能扫码登录
              if (userUsbType == '6') {
                warningMsg && message.warning(warningMsg);
                this.setStateAndCache('loginType', 'QRCode');
              }
            });
          },
        });
    });
  }

  // 扫码登录
  @action
  onQCLogin(cusQrcodeValidTime, cusQrcodeReqTime) {
    // 二维码已失效
    if (this.qrcodeIsInvalid) {
      return;
    }

    const queryParams = this.queryParams;
    const { logintype = '1', gopage = '', target = '1' } = queryParams;
    const { langId, langText, qrCode = {}, loginSettingInfo = {} } = this.state;
    const { loginInfo = {} } = loginSettingInfo;
    const { isOpenGopage = true } = loginInfo;
    const reqStart = new Date();
    LOGIN_API.login4qc({
      langid: langId,
      loginkey: qrCode.loginkey,
      isie: ua.browser == 'IE',
      ...queryParams,
    }).then((result) => {
      if (result.status == '1') {
        // 设置多时区
        jQuery.setSessionTimeZone && jQuery.setSessionTimeZone();

        setLSValue('login', 'logintype', logintype);

        // 跳转
        const params = { isQCLogin: true, isOpenGopage };
        this.onLoginJump(params, queryParams, result);
      } else if(result.status == '-1') {
        message.error(result.msg);
        this.onQCLoginEnd();
      } else {
        const reqEnd = new Date();
        const timeSpend = reqEnd - reqStart;
        if(timeSpend >= cusQrcodeReqTime * 1000) {
          this.onPollingStart(cusQrcodeValidTime, cusQrcodeReqTime);
        } else {
          if(this.pollingTimeout) {
            window.clearTimeout(this.pollingTimeout);
          }
          this.pollingTimeout = setTimeout(()=>{
            this.onPollingStart(cusQrcodeValidTime, cusQrcodeReqTime);
          }, cusQrcodeReqTime * 1000 - timeSpend);
        }

      }
    });
  }

  @action
  onLoginJump(params = {}, queryParams = {}, result = {}) {
    // CAS跳转
    if (result.casflag == '1' && result.casurl) {
      window.location.href = result.casurl;
      return;
    }

    doEvent('afterLogin', () => {
      let jumpUrl = '';

      // 跳转到客户门户页面
      if (queryParams.logintype == '2') {
        jumpUrl = '/spa/crmPortal/mobx/index.html#/main';
      }

      // 跳转到后端引擎页面
      if (result.needJumpToBackstage) {
        jumpUrl = '/wui/engine.html';
      }

      // 跳转到登录超时前页面
      const ls_gopage = WeaTools.ls.getStr('gopage');
      if (ls_gopage && params.isOpenGopage && queryParams.logintype != '2') {
        WeaTools.ls.set('gopage', '');
        jumpUrl = window.decodeURIComponent(ls_gopage);
      }

      // 自定义登录回调
      let { needDefaultJump = true } = result;
      if (window.onLoginCallback && typeof window.onLoginCallback == 'function') {
        needDefaultJump = window.onLoginCallback(result);
      }

      if (needDefaultJump) {
        const defaultJump = (params, queryParams, jumpUrl) => {
          // 跳转到指定页面
          if (jumpUrl) {
            window.top.location.href = addContentPath(jumpUrl);
            return;
          }

          // 判断登录日期和打开登录页日期是否为同一天，不是同一天则需要强制刷新页面，防止页面缓存
          const date = new Date();
          const loginDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
          const ls_loginDate = WeaTools.ls.getStr('loginDate');

          if (!/\/wui\/index\.html/.test(window.top.location.pathname)) {
            window.top.location.href = addContentPath('/wui/index.html#/main');
          } else if (loginDate != ls_loginDate) {
            WeaTools.ls.set('loginDate', loginDate);
            let href = '/wui/index.html?#/main';
            if (queryParams.gopage) {
              href += `?gopage=${window.encodeURIComponent(queryParams.gopage)}&target=${queryParams.target || '1'}`;
            }
            window.top.location.href = addContentPath(href);
          } else {
            // 清除动态密码倒计时
            this.dynamicPasswordTime = 0;
            window.clearInterval(this.dynamicPasswordInterval);
            // 取消登录事件状态
            this.beforLoginRenderEventStatus = false;
            this.afterLoginRenderEventStatus = false;
            // 取消登录状态
            this.setState({ isLogging: false });

            let pathname = '/main';
            if (queryParams.gopage) {
              pathname += `?gopage=${window.encodeURIComponent(queryParams.gopage)}&target=${queryParams.target || '1'}`;
            }
            window.top.weaHistory.push({ pathname });
          }
        };

        LOGIN_API.getDelegateSSO(queryParams)
          .then((result) => {
            let { isDelegate, ec_isuse, delegateLogin_URL, delegateCheckLogin_URL } = result;
            if(isDelegate && ec_isuse){
              if (delegateLogin_URL && delegateCheckLogin_URL) {
                WeaTools.callApi(delegateLogin_URL, 'GET').then((result) => {
                  if (result && result.isLogined == true) {
                    if (result.serviceURL) {
                      window.top.location.href = addContentPath(result.serviceURL);
                      return;
                    }else{
                      defaultJump(params, queryParams, jumpUrl);
                    }
                  } else {
                    message.error(getLabel('521345,498', 'Delegate认证失败'));
                    this.setState({ isLogging: false });
                    LOGIN_API.getDelegateSSO({ command: 'clearDelegateID' });
                  }
                });

              } else {
                message.error(getLabel('521345,498', 'Delegate认证失败'));
                this.setState({ isLogging: false });
                LOGIN_API.getDelegateSSO({ command: 'clearDelegateID' });
              }
            }else{
              defaultJump(params, queryParams, jumpUrl);
            }

          })
          .catch(() => defaultJump(params, queryParams, jumpUrl));
      }
    });
  }

  @action
  onQCLoginStart(cusQrcodeValidTime, cusQrcodeReqTime) {
    this.qrcodeIsInvalid = false; // 二维码生效

    const qrcodeValidTime = cusQrcodeValidTime || this.qrcodeValidTime;//二维码有效时间,30
    let qrcodeReqTime;//扫码频率
    if(cusQrcodeReqTime) {
      qrcodeReqTime = cusQrcodeReqTime == 1 ? 2 : cusQrcodeReqTime;
    } else {
      qrcodeReqTime = this.qrcodeReqTime == 1 ? 2 : this.qrcodeReqTime;
    }

    this.qrcodeCdInterval = window.setInterval(() => {
      if (this.qrcodeUsedTime >= qrcodeValidTime) {
        this.onQCLoginEnd();
      }
      this.qrcodeUsedTime++;
    },  1000);

    // this.qrcodeLoginInterval = window.setInterval(() => this.onQCLogin(), qrcodeReqTime * 1000);

    this.onPollingStart(qrcodeValidTime, qrcodeReqTime);
  }

  @action
  onPollingStart(cusQrcodeValidTime, cusQrcodeReqTime) {
    const qrcodeValidTime = cusQrcodeValidTime || this.qrcodeValidTime;//二维码有效时间或者叫做次数,30
    if (this.qrcodeUsedTime >= qrcodeValidTime) {
      this.onQCLoginEnd();
    }
    this.onQCLogin(cusQrcodeValidTime, cusQrcodeReqTime);
  }

  @action
  onQCLoginEnd() {
    this.qrcodeIsInvalid = true; // 二维码失效
    this.qrcodeUsedTime = 0; // 扫描次数恢复默认
    window.clearInterval(this.qrcodeCdInterval);
    window.clearInterval(this.qrcodeLoginInterval);
  }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/stores/LoginStore.js